import { Drawer, Layout as AntLayout, Col, Row, Typography } from 'antd';
import { MenuFoldOutlined, MenuOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actions } from './Layout.redux';
import LayoutNavigation from './LayoutNavigation';
import useIsDesktop from '@/hooks/useIsDesktop';

const { Header, Footer, Content, Sider } = AntLayout;
const year = new Date().getFullYear();

const Layout = (props) => {
	const dispatch      = useDispatch(),
		  loggedIn      = useSelector(state => state.auth.loggedIn),
		  title         = useSelector(state => state.layout.title),
		  menuCollapsed = useSelector(state => state.layout.menuCollapsed);

	// Below the lg breakpoint the sider is replaced by a hamburger-triggered drawer.
	const isDesktop = useIsDesktop();
	const [ drawerOpen, setDrawerOpen ] = useState(false);

	useEffect(() => {
		if (isDesktop) {
			setDrawerOpen(false);
		}
	}, [ isDesktop ]);

	const toggleShowMenu = () => dispatch(actions.setState({ menuCollapsed: !menuCollapsed }));

	return (
		<AntLayout>

			<Header className="ts_header">
				<Row>
					<Col>
						{
							(loggedIn && isDesktop && !menuCollapsed) && <MenuFoldOutlined className="ts_nav_collapse_icon" onClick={toggleShowMenu} />
						}
						{
							(loggedIn && isDesktop && menuCollapsed) && <MenuUnfoldOutlined className="ts_nav_collapse_icon" onClick={toggleShowMenu} />
						}
					</Col>
					<Col>
						<a href="/"><div className="header_logo" alt={import.meta.env.VITE_COMPANY_NAME} /></a>
					</Col>
					<Col className="ts_header_title_container">
						<Typography.Title level={2} className="ts_header_title">
							{title}
						</Typography.Title>
					</Col>
					<Col className="ts_hamburger_col">
						{
							(loggedIn && !isDesktop) && <MenuOutlined className="ts_hamburger_icon" onClick={() => setDrawerOpen(true)} />
						}
					</Col>
				</Row>

			</Header>


			<AntLayout>
				{(loggedIn && isDesktop) &&
				<Sider trigger={null} collapsible collapsed={menuCollapsed} className="ts_sider_container">
					<LayoutNavigation />
				</Sider>
				}

				{(loggedIn && !isDesktop) &&
				<Drawer
					placement="right"
					closable
					onClose={() => setDrawerOpen(false)}
					open={drawerOpen}
					width={256}
					className="ts_nav_drawer"
				>
					<LayoutNavigation onNavigate={() => setDrawerOpen(false)} />
				</Drawer>
				}

				<div className="nonheader_wrapper">
					<Content className="ts_content">
						{props.children}
					</Content>

					<Footer className="ts_footer" align="center">
						&copy; {year} {import.meta.env.VITE_COMPANY_NAME}. All rights reserved. &nbsp; <b>{import.meta.env.VITE_APP_VERSION}</b>
					</Footer>
				</div>
			</AntLayout>


		</AntLayout>
	);
};


export default Layout;
